






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import JobDto from '@/models/Jobs/JobDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import UpdateJobRequirementsRequest from '@/models/Jobs/UpdateJobRequirementsRequest';

@Component({
    name: 'JobRequirementsEdit'
})
export default class JobRequirementsEdit extends GiganautVueDialog {
 
  entity: JobDto = new JobDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(JobDetailsModule.currentJob));
      if (AgencySettingsModule.positions) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications) {
        await AgencySettingsModule.getQualifications();
      }
    }
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateJobRequirementsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.primaryPositionId = this.entity.primaryPosition.id;
    request.secondaryPositionIds = [];
    if (this.entity.secondaryPositions.length > 0) {
      for (let index = 0; index < this.entity.secondaryPositions.length; index++) {
        const position = this.entity.secondaryPositions[index];
        request.secondaryPositionIds.push(position.id);
      }
    }
    if (this.entity.primarySkills.length > 0) {
      for (let index = 0; index < this.entity.primarySkills.length; index++) {
        const skill = this.entity.primarySkills[index];
        request.primarySkillIds.push(skill.id);
      }
    }
    if (this.entity.secondarySkills.length > 0) {
      for (let index = 0; index < this.entity.secondarySkills.length; index++) {
        const skill = this.entity.secondarySkills[index];
        request.secondarySkillIds.push(skill.id);
      }
    }
    if (this.entity.primaryQualifications.length > 0) {
      for (let index = 0; index < this.entity.primaryQualifications.length; index++) {
        const qual = this.entity.primaryQualifications[index];
        request.primaryQualificationIds.push(qual.id);
      }
    }
    if (this.entity.secondaryQualifications.length > 0) {
      for (let index = 0; index < this.entity.secondaryQualifications.length; index++) {
        const qual = this.entity.secondaryQualifications[index];
        request.secondaryQualificationIds.push(qual.id);
      }
    }
    await JobDetailsModule.editJobRequirements(request)
    this.dialog = false;
  }
}
